/**
 * Resource that list all events
 */
export const eventsResource = 'Evento';
/**
 * Resource that list all next events
 */
export const listNextEventsResource = 'Evento/ListarProximos';
/**
 * Resource that list all previous events
 */
export const listPreviousEventsResource = 'Evento/ListarAnteriores';
/**
 * Resource of Event Types
 */
export const eventTypesResource = 'TiposEvento';
/**
 * Resource of Login
 */
export const loginResource = 'Login';
/**
 * Resource of Event Presence
 */
export const eventPresencesResource = 'PresencasEvento';

/**
 * Resource of Commentary
 */
export const CommentaryResource = 'ComentariosEvento';